import React from "react";

const About = () => (
  <div className="page-container">
    <div className="page-content">
      <h1 className="page-title">About Simple Step Counter</h1>
      <section className="about-section">
        <h2>Independently Developed</h2>
        <p>
          Hi! I built this app because every other step counter I tried was either unreliable, full of ads, charged money for basic features, or was made by giant corporations with poor privacy practices. I wanted something better—so I made it myself.
        </p>
        <p>
          Simple Step Counter is reliable, minimalist, elegant, highly customizable, and truly respects your privacy. There are no ads, minimal tracking, and the base version is completely free. The app follows the Unix philosophy: <em>"Do one thing, and do it well."</em> I believe it’s a quality product you can trust.
        </p>
      </section>
      <section className="about-section">
        <h2>Support This Project</h2>
        <p>
          If you want to support my work, please consider buying the in-app purchase, leaving a 5-star review, sending a donation via PayPal, or sharing your experience online. Every bit of support helps me keep improving the app!
        </p>
      </section>
      <section className="about-section">
        <h2>Contact Me</h2>
        <p>
          I love hearing your suggestions and ideas—if you have a feature request or improvement, please let me know! If you encounter any problems, please email me directly instead of leaving a bad review. Your feedback is important and helps me make the app even better for everyone.
        </p>
        <p>
          You can find my contact information on the <a href="/help#contact" className="inline-link">Help page</a>.
        </p>
      </section>
    </div>
  </div>
);

export default About;
